export const NOTIFICATIONS_TSV_FILE = 'NotificationsTsvFile';
export const NODES_TSV_FILE = 'NodesTsvFile';
export const EDGES_TSV_FILE = 'EdgesTsvFile';

// node attributes
export const STATUS = "status";  // used for nodes and edges
export const NAME = "name";
export const TYPE = "type";
export const INVESTIGATED = "investigated";
export const CONNECTIONS = "connections";
export const LATITUDE = "latitude";
export const LONGITUDE = "longitude";
export const COST = "cost";
export const NOTIFICATIONS = "notifications";
export const GROUP = "group";

export const ROLE = "role";
export const MESSAGE = "message";
export const DESCRIPTION = "description";

export const COST_TO_SHUT_DOWN = "cost_to_shut_down";
export const COST_IF_INFECTED = "cost_if_infected";
export const GOODWILL_COST = "goodwill_cost";

export const SOURCE_NODE = "source";
export const DESTINATION_NODE = "target";

export const NOTIFICATIONS_TSV_COLUMNS = [STATUS, TYPE, GROUP, NAME, ROLE, MESSAGE];
export const NODE_TSV_COLUMNS = [NAME, GROUP, DESCRIPTION, "unused_cost", "unused1", "unused2", "unused3", "unused4", LONGITUDE,
                    LATITUDE, COST_TO_SHUT_DOWN, COST_IF_INFECTED, GOODWILL_COST];
export const EDGE_TSV_COLUMNS = [SOURCE_NODE, DESTINATION_NODE];

export const TOTAL_ROUNDS = 3;
export const ACTIONS_PER_ROUND_PER_ROLE = 3;

// internal statuses
export const HEALTHY = "healthy"; // the node has been investigated and is decisively healthy (at least for the current round; it turns yellow if vulnerable)
// the node is infected. This shows if 1) the players investigated the node or 2) it has been 2(?) rounds since the node first became infected
export const INFECTED_SPREAD = "infected_spread"; // this type of attack spreads to all neighbor nodes each round
export const INFECTED_DIRECTED = "infected_directed"; // this type of attack spreads like a "snake" in a random direction
export const OFF = "off";
// front-facing statuses
export const COMPROMISED = "compromised";
export const UNKNOWN = "unknown";

// edge statuses
export const UP = "up";
export const DOWN = "down";

// role names
export const PIO = "pio";
export const SCADA = "scada";
export const SOC = "soc";
export const IT = "it";
export const ALL_ROLES = [PIO, SCADA, SOC, IT];

export const PC = "pc";
export const SERVER = "server";
export const ALL_DEVICE_TYPES = [PC, SERVER, SCADA];

export const ELECTRIC_GROUP = "electric";
export const IT_GROUP = "it";
export const WATER_GROUP = "water";
export const OFFICES_GROUP = "offices";
export const CITY_GROUP = "city";
export const HOSPITAL_GROUP = "hospital";
export const TRANSPORTATION_GROUP = "transportation";
export const ALL_GROUPS = [ELECTRIC_GROUP, IT_GROUP, WATER_GROUP, OFFICES_GROUP, CITY_GROUP, HOSPITAL_GROUP, TRANSPORTATION_GROUP];

// this exists because the groups in the spreadsheet may not exactly match the group names in the game
export const NETWORK_TSV_GROUP_MAP = {
    "it dept.": IT_GROUP,
    "hospital": HOSPITAL_GROUP,
    "transportation": TRANSPORTATION_GROUP,
    "electric": ELECTRIC_GROUP,
    "offices": OFFICES_GROUP,
    "water": WATER_GROUP
}